<header *ngIf="label">
  @if (expanded) {
    <div class="flex items-center gap-2">
      <h3>{{ label }}</h3>
      @if (tooltip) {
        <mat-icon [matTooltip]="tooltip">info_outline</mat-icon>
      }
    </div>

    @if (matMenu) {
      <button
        mat-icon-button
        class="menu-trigger"
        [matMenuTriggerFor]="matMenu"
        [matTooltip]="matMenuTooltip"
        [matTooltipDisabled]="!matMenuTooltip"
      >
        <mat-icon>arrow_drop_down</mat-icon>
      </button>
    }
  } @else {
    <div class="mb-1 flex justify-center opacity-50">
      <mat-icon>horizontal_rule</mat-icon>
    </div>
  }
</header>

<div class="links">
  <ng-container *ngFor="let link of links; trackBy: trackByLink">
    <ng-container *prHasPermission="link.feature?.permissions">
      <ng-container *prIsRegion="link.feature?.regions ?? allRegions">
        <ng-container *ptFeatureEnabled="link.feature?.label">
          @if (!link.children?.length) {
            <a
              routerLinkActive="selected"
              [routerLink]="{ routePrefix, link } | map: getRoutePath"
              [routerLinkActiveOptions]="{ exact: false }"
              [ptIntercomTarget]="link | map: getIntercomTarget : this"
            >
              <pr-sidebar-link
                *prHasPermission="link.permissions"
                matRipple
                [feature]="link.feature"
                [label]="link.label"
                [icon]="link.display?.icon"
                [badge]="link.badge$ | async"
                [expanded]="expanded"
                (click)="closeSidebarIfMobile()"
              />
            </a>
          } @else {
            <ng-container *prHasPermission="link.permissions">
              <pr-sidebar-link
                matRipple
                class="sub-menu-trigger flex-1"
                [matMenuTriggerFor]="subMenu"
                [feature]="link.feature"
                [label]="link.label"
                [icon]="link.display?.icon"
                [badge]="link.badge$ | async"
                [expanded]="expanded"
                (click)="closeSidebarIfMobile()"
              >
                <mat-icon>menu_open</mat-icon>
              </pr-sidebar-link>

              <mat-menu #subMenu="matMenu" class="sidebar-mat-menu">
                @for (subLink of link.children; track subLink.label) {
                  <a
                    mat-menu-item
                    routerLinkActive="selected"
                    [routerLink]="
                      { routePrefix, link: subLink } | map: getRoutePath
                    "
                    [routerLinkActiveOptions]="{ exact: false }"
                    [ptIntercomTarget]="subLink | map: getIntercomTarget : this"
                  >
                    <pr-sidebar-link
                      *prHasPermission="subLink.permissions"
                      matRipple
                      [feature]="subLink.feature"
                      [label]="subLink.label"
                      [icon]="subLink.display?.icon"
                      [badge]="subLink.badge$ | async"
                      [expanded]="true"
                      (click)="closeSidebarIfMobile()"
                    />
                  </a>
                }
              </mat-menu>
            </ng-container>
          }
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
</div>
